import { useEffect } from "react";
import { Footer } from "src/v1/ui/footer/Footer";
import { useTossPixelProductView } from "src/hooks/useAds";
import { BottomRightLink } from "src/components/BottomRightLink";
import {
  CompanyBanner,
  CompanyLawyers,
  CompanyMerit,
  CompanyPartner,
} from "./components";

export default function CompanyPage() {
  // Danggeun Market tracking script
  useEffect(() => {
    if (window.karrotPixel && typeof window.karrotPixel.track === "function") {
      window.karrotPixel.track("ViewContent");
    }
  }, []);

  // Toss Pixel tracking
  useTossPixelProductView({
    product_id: "lawyer-intro-page",
    product_name: "변호사 소개",
  });

  return (
    <main className="">
      <CompanyBanner />
      <CompanyLawyers />
      <CompanyMerit />
      <CompanyPartner />
      <Footer />
      <BottomRightLink />
    </main>
  );
}
